export class DeepDiveDetails {
  DomainType: string;
  FdsLevel: number;
  UserId: string;
  ProposalId: Number;
  isSAP: boolean;
  VersionId: number;
  VersionIdMongo: string;
  DDName: string;
  UploadedDate: string;
  ModifiedOn: string;
  Status: string;
  ShowHide: boolean;
  NotificationStatus: string;
  E2EUID: string;
  CMSUID: string;
  WSUID: string;
  DeliveryConstructUId: string;
  FdsType: string;
  UserType: number;
  AjNotification: number;
  TotalCategory: number;
  CategorisedTicketcount: number;
  TotalTicketCount: number;
  ProgressStatus :string;
  DQTStatus : string;
}
